import { Dot, LoadingDotsContainer } from './styles';

const LoadingDots = () => (
  <LoadingDotsContainer>
    <Dot />
    <Dot />
    <Dot />
  </LoadingDotsContainer>
);

export default LoadingDots;
